import { render } from "./MFlag.vue?vue&type=template&id=6b51e1b0&scoped=true"
import script from "./MFlag.vue?vue&type=script&lang=js"
export * from "./MFlag.vue?vue&type=script&lang=js"

import "./MFlag.vue?vue&type=style&index=0&id=6b51e1b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b51e1b0"]])

export default __exports__